import React, { useContext } from "react";
import Button from "@mui/material/Button";
import {
  BLUE_30,
  SUBMIT_BUTTON_STYLES,
} from "../../../constants/css.constants";
import { AtOnceContext } from "../../../contexts/AtOnceContext";
import { createWorksheet } from "../../../xls/createWorksheet";
import { DistributionContext } from "../../../contexts/DistributionContext";
import { FuturesContext } from "../../../contexts/FuturesContext";
import { SeasonToMonthContext } from "../../../contexts/SeasonToMonthContext";
import { ShipmentHeaderContext } from "../../../contexts/ShipmentHeaderContext";

const DownloadButton = ({
  tab,
  pathname,
  country,
}: {
  tab: string;
  pathname: string;
  country: string;
}) => {
  const {
    horizontalHeaders,
    verticalSeasons,
    verticalMonths,
    monthsInFirstTwoSeasons,
  } = useContext(ShipmentHeaderContext);
  const { distributionData } = useContext(DistributionContext);
  const { atOnceData } = useContext(AtOnceContext);
  const { futuresData, futuresTotals } = useContext(FuturesContext);
  const { seasonToMonthData, cupData } = useContext(SeasonToMonthContext);
  const onDownload = async () => {
    const isNVS = pathname.includes("nvs");
    const is3PW = pathname.includes("3pw");
    const url = await createWorksheet(
      tab,
      {
        atOnce: atOnceData,
        distribution: distributionData,
        futures: futuresData,
        futuresTotals,
        seasonToMonthData,
        cupData,
      },
      isNVS,
      {
        horizontalHeaders,
        verticalSeasons,
        verticalMonths,
        monthsInFirstTwoSeasons,
      },
      is3PW,
    );
    const link = document.createElement("a");
    link.href = url;
    const paths = pathname.split("/")[1].split("-");
    link.download = `${paths[0].toUpperCase()} ${paths
      .slice(1)
      .join(" ")
      .toUpperCase()} ${country.toUpperCase()} ${tab}`;
    // Append to html link element page
    document.body.appendChild(link);

    // Start download
    link.click();

    // Clean up and remove the link
    //@ts-ignore
    link.parentNode.removeChild(link);
  };
  return (
    <Button
      style={SUBMIT_BUTTON_STYLES(BLUE_30)}
      variant="contained"
      onClick={onDownload}
      size="large"
    >
      Download
    </Button>
  );
};

export default DownloadButton;
